import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
// @ts-nocheck
import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store';
import defaultView from '@/layout/index.vue';
const Layout = defaultView;
// import systemManagement from './modules/systemManagement'
export const asyncRoutes = [
// 404 page must be placed at the end !!!
{
  path: '/:pathMatch(.*)*',
  redirect: '/srm/dashboard'
}];
const constantRoutes = [{
  path: '/404',
  component: () => import('@/views/error-page/404.vue')
}, {
  path: '/401',
  component: () => import('@/views/error-page/401.vue')
},
// SRM start
{
  path: '/auth',
  name: 'supplier',
  children: [{
    path: 'login',
    name: 'supplierRegisterLogin',
    component: () => import('@/views/srm/supplier/supplier-register/login.vue'),
    meta: {
      title: 'pc-router-0',
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'register',
    name: 'RegisterAgree',
    component: () => import('@/views/srm/supplier/supplier-register/agree.vue'),
    meta: {
      title: 'pc-router-1',
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-register-detail',
    name: 'RegisterDetail',
    component: () => import('@/views/srm/supplier/supplier-register/detail.vue'),
    meta: {
      title: 'pc-router-2',
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'biellogin',
    name: 'biel-login',
    component: () => import('@/views/srm/login/login.vue'),
    meta: {
      title: 'ops-login',
      icon: 'goods',
      detail: true
    }
  }],
  ...asyncRoutes
},
// 专家答疑
{
  path: '/open',
  name: 'open',
  children: [{
    path: 'expert-reply',
    name: 'expert-reply',
    component: () => import('@/views/srm/zblxManage/questionReply/questionReplyEmail.vue'),
    meta: {
      title: 'pc-router-3',
      icon: 'goods',
      detail: true,
      enable: false
    }
  }],
  ...asyncRoutes
}, {
  path: '/srm',
  name: 'srm',
  component: Layout,
  children: [{
    path: 'dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/index.vue'),
    meta: {
      title: 'pc-router-4',
      icon: 'dashboard',
      requireAuth: true,
      supplierAuth: true,
      affix: true
    }
  }, {
    path: 'zblx-index',
    name: 'zblxIndex',
    component: () => import('@/views/srm/zblxManage/index.vue'),
    meta: {
      title: 'pc-needBiddingMissionPool-11',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'zblx-detail',
    name: 'zblxDetail',
    component: () => import('@/views/srm/zblxManage/detail.vue'),
    meta: {
      title: 'pc-router-5',
      requireAuth: true,
      detail: false
    }
  }, {
    path: 'fada-index',
    name: 'fadaIndex',
    component: () => import('@/views/srm/zblxManage/planSettle/index.vue'),
    meta: {
      title: 'pc-router-6',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'fada-detail',
    name: 'fadaDetail',
    component: () => import('@/views/srm/zblxManage/planSettle/detail.vue'),
    meta: {
      title: 'pc-router-6',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'zbgc-index',
    name: 'zbgcIndex',
    component: () => import('@/views/srm/zbgcManage/index.vue'),
    meta: {
      title: 'pc-router-7',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'price-type-rule',
    name: 'priceTypeRule',
    component: () => import('@/views/srm/priceTypeRule/search.vue'),
    meta: {
      title: 'pc-priceTypeRule-7',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'risk-manage-index',
    name: 'riskManageIndex',
    component: () => import('@/views/srm/riskManage/index.vue'),
    meta: {
      title: 'pc-router-8',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'risk-manage-detail',
    name: 'riskManageDetail',
    component: () => import('@/views/srm/riskManage/detail.vue'),
    meta: {
      title: 'pc-router-9',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'margin-index',
    name: 'marginIndex',
    component: () => import('@/views/srm/marginManage/index.vue'),
    meta: {
      title: 'pc-router-10',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'margin-refund-detail',
    name: 'marginRefundDetail',
    component: () => import('@/views/srm/marginManage/refundDetail.vue'),
    meta: {
      title: 'pc-router-11',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'margin-refund-list',
    name: 'marginRefundList',
    component: () => import('@/views/srm/marginManage/refundList.vue'),
    meta: {
      title: 'pc-router-12',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'margin-msxx-list',
    name: 'marginMsxxList',
    component: () => import('@/views/srm/marginManage/msxxList.vue'),
    meta: {
      title: 'pc-router-13',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'margin-confiscated-detail',
    name: 'marginConfiscatedDetail',
    component: () => import('@/views/srm/marginManage/confiscatedDetail.vue'),
    meta: {
      title: 'pc-router-14',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'margin-confiscated-cancel',
    name: 'marginConfiscatedCancel',
    component: () => import('@/views/srm/marginManage/confiscatedCancel.vue'),
    meta: {
      title: 'pc-router-15',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'bidding-mode-rule',
    name: 'biddingModeRule',
    component: () => import('@/views/srm/ruleLib/biddingModeRule/searchList.vue'),
    meta: {
      title: 'pc-router-16',
      requireAuth: true,
      icon: 'goods'
    }
  }, {
    path: 'zbgc-single-config-index',
    name: 'zbgcSingleConfigIndex',
    component: () => import('@/views/srm/zbgcSingleConfig/index.vue'),
    meta: {
      title: 'pc-router-17',
      requireAuth: true,
      icon: 'interface',
      detail: true
    }
  }, {
    path: 'zbgc-single-create-form',
    name: 'zbgcSingleCreateForm',
    component: () => import('@/views/srm/zbgcSingleConfig/createForm.vue'),
    meta: {
      title: 'pc-router-18',
      requireAuth: true,
      icon: 'interface',
      detail: true
    }
  }, {
    path: 'zbgc-single-config-detail',
    name: 'zbgcSingleConfigDetail',
    component: () => import('@/views/srm/zbgcSingleConfig/detail.vue'),
    meta: {
      title: 'pc-router-19',
      requireAuth: true,
      icon: 'interface',
      detail: true
    }
  }, {
    path: 'need-bidding-mission-pool',
    name: 'needBiddingMissionPool',
    component: () => import('@/views/srm/needBiddingMissionPool/index.vue'),
    meta: {
      title: 'pc-router-20',
      requireAuth: true,
      icon: 'goods',
      detail: false,
      noCache: true
    }
  }, {
    path: 'waste-materials',
    name: 'wasteMaterials',
    component: () => import('@/views/srm/wasteMaterials/index.vue'),
    meta: {
      title: 'pc-router-21',
      requireAuth: true,
      detail: false,
      noCache: true
    }
  }, {
    path: 'need-bidding-add',
    name: 'needBiddingMissionPoolAdd',
    component: () => import('@/views/srm/needBiddingMissionPool/singList/createDetail.vue'),
    meta: {
      title: 'pc-router-22',
      requireAuth: true,
      icon: 'goods',
      detail: false,
      noCache: true
    }
  }, {
    path: 'periodicity-pricing-detail',
    name: 'periodicityPricingDetail',
    component: () => import('@/views/srm/needBiddingMissionPool/periodicityPricing/detail.vue'),
    meta: {
      title: 'pc-router-23',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'evaluate-business-bid',
    name: 'evaluateBusinessBid',
    component: () => import('@/views/srm/zblxManage/evaluateBusinessBid/index.vue'),
    meta: {
      title: 'pc-router-24',
      requireAuth: true,
      icon: 'interface',
      affix: true
    }
  }, {
    path: 'zxlx-question-reply',
    name: 'zxlxQuestionReply',
    component: () => import('@/views/srm/zblxManage/questionReply/index.vue'),
    meta: {
      title: 'pc-router-25',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'zxlx-question-reply-detail',
    name: 'zxlxQuestionReplyDetail',
    component: () => import('@/views/srm/zblxManage/questionReply/questionReplyDetail.vue'),
    meta: {
      title: 'pc-router-3',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'bidding-type-rule',
    name: 'biddingTypeRule',
    component: () => import('@/views/srm/ruleLib/biddingTypeRule/searchList.vue'),
    meta: {
      title: 'pc-router-26',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'need-confirm-demand-pool',
    name: 'needConfirmDemandPool',
    component: () => import('@/views/srm/needConfirmDemandPool/index.vue'),
    meta: {
      title: 'pc-router-27',
      requireAuth: true,
      icon: 'goods'
    }
  }, {
    path: 'zbmb-config-index',
    name: 'zbmb-config-index',
    component: () => import('@/views/srm/zbmbConfig/index.vue'),
    meta: {
      title: 'pc-router-28',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'zbmb-config-detail',
    name: 'zbmb-config-detail',
    component: () => import('@/views/srm/zbmbConfig/detail.vue'),
    meta: {
      title: 'pc-router-29',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'tender-list',
    name: 'ispTenderList',
    component: () => import('@/views/srm/supplier/tenderList/index.vue'),
    meta: {
      title: 'pc-router-30',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'tender-list-detail',
    name: 'ispTenderListDetail',
    component: () => import('@/views/srm/supplier/tenderList/tenderDetail.vue'),
    meta: {
      title: 'pc-router-31',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'tender-bqjd',
    name: 'ispTenderBqjd',
    component: () => import('@/views/srm/supplier/bqjd/index.vue'),
    meta: {
      title: 'pc-router-32',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'tender-ty',
    name: 'ispTenderTy',
    component: () => import('@/views/srm/supplier/ty/index.vue'),
    meta: {
      title: 'pc-router-33',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'hb-list',
    name: 'hb-list',
    component: () => import('@/views/srm/supplier/supplier-reply/index.vue'),
    meta: {
      title: 'pc-router-34',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'ty-list',
    name: 'tyList',
    component: () => import('@/views/srm/supplier/ty/tyList/index.vue'),
    meta: {
      title: 'pc-router-35',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'hb-materials',
    name: 'hbMaterials',
    component: () => import('@/views/srm/supplier/clhb/index.vue'),
    meta: {
      title: 'pc-router-36',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-register-login',
    name: 'supplier-register-login',
    component: () => import('@/views/srm/supplier/supplier-register/login.vue'),
    meta: {
      title: 'pc-router-0',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-register-agree',
    name: 'supplier-register-agree',
    component: () => import('@/views/srm/supplier/supplier-register/agree.vue'),
    meta: {
      title: 'pc-router-1',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-register-detail',
    name: 'SupplierRegisterDetail',
    component: () => import('@/views/srm/supplier/supplier-register/detail.vue'),
    meta: {
      title: 'pc-router-2',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'add-supplier',
    name: 'zxlxAddSupplier',
    component: () => import('@/views/srm/zblxManage/addSupplier/index.vue'),
    meta: {
      title: 'pc-router-37',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'send-bid-detail',
    name: 'zxlxSendBidDetail',
    component: () => import('@/views/srm/zblxManage/sendBid/sendBid.vue'),
    meta: {
      title: 'pc-router-38',
      icon: 'goods',
      detail: false
    }
  }, {
    path: 'bjmx-config-detail',
    name: 'bjmxConfigdetail',
    component: () => import('@/views/srm/ruleLib/bjmxConfig/detailAll.vue'),
    meta: {
      title: 'pc-router-39',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'bjmx-config-detail-preview-router-dialog',
    name: 'bjmxConfigdetailPreviewRouterDialog',
    component: () => import('@/views/srm/ruleLib/bjmxConfig/previewRouterDialog.vue'),
    meta: {
      title: 'pc-router-40',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-ready-approval',
    name: 'supplier-ready-approval',
    component: () => import('@/views/srm/supplier/ready-approval/search.vue'),
    meta: {
      title: 'pc-ready-approval-0',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-ready-approval-detail',
    name: 'supplier-ready-approval-detail',
    component: () => import('@/views/srm/supplier/ready-approval/detail.vue'),
    meta: {
      title: 'pc-router-41',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-ready-approval-factory',
    name: 'supplier-ready-approval-factory',
    component: () => import('@/views/srm/supplier/ready-approval/searchFactory.vue'),
    meta: {
      title: 'pc-ready-approval-factory-2',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-factory-detail',
    name: 'supplier-factory-detail',
    component: () => import('@/views/srm/supplier/ready-approval/factoryDetail.vue'),
    meta: {
      title: 'pc-router-42',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'inner-register',
    name: 'supplier-inner-register',
    component: () => import('@/views/srm/supplier/inner-register/search.vue'),
    meta: {
      title: 'pc-router-43',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'inner-detail',
    name: 'supplier-inner-detail',
    component: () => import('@/views/srm/supplier/inner-register/detail-teamwork.vue'),
    meta: {
      title: 'pc-router-44',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'inspect-start',
    name: 'supplier-inspect-start',
    component: () => import('@/views/srm/supplier/inspect/inspect-start/index.vue'),
    meta: {
      title: 'pc-router-45',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'inspect-question',
    name: 'supplier-inspect-question',
    component: () => import('@/views/srm/supplier/inspect/inspect-question/index.vue'),
    meta: {
      title: 'pc-router-46',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'inspect-report',
    name: 'supplier-inspect-report',
    component: () => import('@/views/srm/supplier/inspect/inspect-report/index.vue'),
    meta: {
      title: 'pc-router-47',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'stock-library',
    name: 'supplier-stock-library',
    component: () => import('@/views/srm/supplier/supplier-stock/library/index.vue'),
    meta: {
      title: 'pc-router-48',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'stock-library-detail-teamwork',
    name: 'supplier-stock-library-detail-teamwork',
    component: () => import('@/views/srm/supplier/supplier-stock/library/detail-teamwork.vue'),
    meta: {
      title: 'pc-router-49',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'stock-manage',
    name: 'supplier-stock-manage',
    component: () => import('@/views/srm/supplier/supplier-stock/manage/index.vue'),
    meta: {
      title: 'pc-router-50',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'purchase-order',
    name: 'purchase-order',
    component: () => import('@/views/mm/order/purchaseOrder/index.vue'),
    meta: {
      title: 'pc-supplier-stock-25',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'purchase-order-detail',
    name: 'purchase-order-detail',
    component: () => import('@/views/mm/order/purchaseOrder/detail.vue'),
    meta: {
      title: 'pc-router-51',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'apply-buy-detail',
    name: 'applyBuyDetail',
    component: () => import('@/views/mm/applyManagement/buy/detail.vue'),
    meta: {
      title: 'pc-router-52',
      requireAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'mm-shippling-plan',
    name: 'mmShipplingPlan',
    component: () => import('@/views/mm/order/shipping/shippingPlan.vue'),
    meta: {
      title: 'pc-shippingPlan-13',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'delivery-plan',
    name: 'deliveryPlan',
    component: () => import('@/views/mm/order/delivery/deliveryPlan.vue'),
    meta: {
      title: 'pc-router-53',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'deliver-goods-index',
    name: 'deliverGoodsIndex',
    component: () => import('@/views/mm/order/deliverGoods/index.vue'),
    meta: {
      title: 'pc-deliverGoods-3',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'deliver-goods-detail',
    name: 'deliverGoodsDetail',
    component: () => import('@/views/mm/order/deliverGoods/detail.vue'),
    meta: {
      title: 'pc-router-54',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'demand-forecast-index',
    name: 'demandForecastIndex',
    component: () => import('@/views/mm/order/demandForecast/index.vue'),
    meta: {
      title: 'pc-router-55',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'bjmx-config-search',
    name: 'bjmxConfigSearch',
    component: () => import('@/views/srm/ruleLib/bjmxConfig/search.vue'),
    meta: {
      title: 'pc-router-56',
      requireAuth: true,
      icon: 'goods',
      detail: false
    }
  }, {
    path: 'zbfj-Rlue-search',
    name: 'zbfjRluesearch',
    component: () => import('@/views/srm/ruleLib/zbfjRlue/search.vue'),
    meta: {
      title: 'pc-router-57',
      requireAuth: true,
      icon: 'goods',
      detail: false
    }
  }, {
    path: 'bzmb-Rule-search',
    name: 'bzmbRulesearch',
    component: () => import('@/views/srm/ruleLib/bzmbRule/search.vue'),
    meta: {
      title: 'pc-router-58',
      requireAuth: true,
      icon: 'goods',
      detail: false
    }
  }, {
    path: 'supplierTemplateFile',
    name: 'supplierTemplateFile',
    component: () => import('@/views/srm/supplier/supplier-register/supplierTemplateFile.vue'),
    meta: {
      title: 'pc-router-59',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: false
    }
  }, {
    path: 'supplier-basic-detail',
    name: 'supplier-basic-detail',
    component: () => import('@/views/srm/supplier/supplier-stock/library/supplierDetail.vue'),
    meta: {
      title: 'pc-router-49',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  },
  //  -------- 对账请款配置-----
  {
    path: 'dzqk-config-index',
    name: 'dzqkConfigIndex',
    component: () => import('@/views/srm/dzqkConfig/index.vue'),
    meta: {
      title: 'pc-router-60',
      requireAuth: true,
      icon: 'interface',
      detail: true
    }
  }, {
    path: 'dzqk-create-form',
    name: 'dzqkCreateForm',
    component: () => import('@/views/srm/dzqkConfig/createForm.vue'),
    meta: {
      title: 'pc-router-61',
      requireAuth: true,
      icon: 'interface',
      detail: true
    }
  }, {
    path: 'dzqk-config-detail',
    name: 'dzqkConfigDetail',
    component: () => import('@/views/srm/dzqkConfig/detail.vue'),
    meta: {
      title: 'pc-router-62',
      requireAuth: true,
      icon: 'interface',
      detail: true
    }
  }, {
    path: 'dzqk-index',
    name: 'dzqkIndex',
    component: () => import('@/views/srm/dzqkManage/index.vue'),
    meta: {
      title: 'pc-dzqkIndex-0',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'dzqk-cwfh-index',
    name: 'dzqkCwfhIndex',
    component: () => import('@/views/srm/dzqkManage/dzqkCwfhIndex.vue'),
    meta: {
      title: 'pc-dzqkCwfhIndex-0',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'dzqk-detail',
    name: 'dzqkDetail',
    component: () => import('@/views/srm/dzqkManage/detail.vue'),
    meta: {
      title: 'pc-dzqkDetail-0',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'price-index',
    name: 'priceIndex',
    component: () => import('@/views/srm/priceTypeRule/index.vue'),
    meta: {
      title: 'pc-router-63',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'price-sign',
    name: 'priceSign',
    component: () => import('@/views/srm/priceSign/index.vue'),
    meta: {
      title: 'pc-router-64',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'price-sign-edit',
    name: 'priceSignEdit',
    component: () => import('@/views/srm/priceSign/edit/index.vue'),
    meta: {
      title: 'pc-router-65',
      icon: 'goods',
      requireAuth: true,
      detail: false
    }
  }, {
    path: 'price-sign-create',
    name: 'priceSignCreate',
    component: () => import('@/views/srm/priceSign/create/index.vue'),
    meta: {
      title: 'pc-router-66',
      icon: 'goods',
      requireAuth: true,
      detail: false
    }
  }, {
    path: 'pay-request-list',
    name: 'payRequestList',
    component: () => import('@/views/srm/payRequest/index.vue'),
    meta: {
      title: 'pc-router-67',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'pay-request-detail',
    name: 'payRequestDetail',
    component: () => import('@/views/srm/payRequest/payDetail.vue'),
    meta: {
      title: 'pc-router-68',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'price-type-detail',
    name: 'priceTypeDetail',
    component: () => import('@/views/srm/priceTypeRule/payDetail.vue'),
    meta: {
      title: 'pc-router-69',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'sg-Import',
    name: 'sgImport',
    component: () => import('@/views/srm/priceTypeRule/sgimport.vue'),
    meta: {
      title: 'pc-priceTypeRule-search-0',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'claim-discount-index',
    name: 'claimDiscountIndex',
    component: () => import('@/views/srm/claimDiscount/index.vue'),
    meta: {
      title: 'pc-router-70',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'claim-discount-detail',
    name: 'claimDiscountDetail',
    component: () => import('@/views/srm/claimDiscount/detail.vue'),
    meta: {
      title: 'pc-claimDiscountDetail-0',
      icon: 'goods',
      requireAuth: true,
      supplierAuth: true,
      detail: true
    }
  }, {
    path: 'contract-pool-index',
    name: 'contractPoolIndex',
    component: () => import('@/views/srm/contractPool/index.vue'),
    meta: {
      title: 'pc-contractPool-10',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'invoice-pool-index',
    name: 'invoicePoolIndex',
    component: () => import('@/views/srm/invoicePool/index.vue'),
    meta: {
      title: 'pc-invoicePool-6',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'supplier-purchase-order',
    name: 'supplierPurchaseOrder',
    component: () => import('@/views/srm/supplier/purchaseOrder/index.vue'),
    meta: {
      title: 'pc-supplier-stock-25',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-dzd-index',
    name: 'supplierDzdIndex',
    component: () => import('@/views/srm/supplier/dzqkManage/index.vue'),
    meta: {
      title: 'pc-supplierDzdIndex-0',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-dzd-detail',
    name: 'supplierDzdDetail',
    component: () => import('@/views/srm/supplier/dzqkManage/detail.vue'),
    meta: {
      title: 'pc-dzqkDetail-0',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-kjfp-detail',
    name: 'supplierKjfpDetail',
    component: () => import('@/views/srm/supplier/dzqkManage/kjfpDetail.vue'),
    meta: {
      title: 'pc-supplierKjfpDetail-0',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-kjfp-index',
    name: 'supplierKjfpIndex',
    component: () => import('@/views/srm/supplier/dzqkManage/kjfpIndex.vue'),
    meta: {
      title: 'pc-supplierKjfpIndex-0',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'supplier-claim-discount-index',
    name: 'supplierClaimDiscountIndex',
    component: () => import('@/views/srm/claimDiscount/index.vue'),
    meta: {
      title: 'pc-supplierClaimDiscountIndex-0',
      requireAuth: true,
      supplierAuth: true,
      icon: 'goods',
      detail: true
    }
  }, {
    path: 'notice-feedback',
    name: 'noticeFeedback',
    component: () => import('@/views/srm/noticeFeedback/index.vue'),
    meta: {
      title: 'pc-noticeFeedback-0',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'notice-feedback-detail',
    name: 'noticeFeedbackDetail',
    component: () => import('@/views/srm/noticeFeedback/detail.vue'),
    meta: {
      title: 'pc-noticeFeedbackDetail-0',
      icon: 'goods',
      requireAuth: true,
      detail: true
    }
  }, {
    path: 'supplier-notice-feedback',
    name: 'supplierNoticeFeedback',
    component: () => import('@/views/srm/supplier/noticeFeedback/index.vue'),
    meta: {
      title: 'pc-noticeFeedback-0',
      icon: 'goods',
      requireAuth: true,
      supplierAuth: true,
      detail: true
    }
  }, {
    path: 'supplier-notice-feedback-detail',
    name: 'supplierNoticeFeedbackDetail',
    component: () => import('@/views/srm/supplier/noticeFeedback/detail.vue'),
    meta: {
      title: 'pc-noticeFeedbackDetail-0',
      icon: 'goods',
      requireAuth: true,
      supplierAuth: true,
      detail: true
    }
  }]
},
// 送货单打印
{
  path: '/print',
  name: 'pring',
  children: [{
    path: 'deliver-goods-Print',
    name: 'deliverGoodsPrint',
    component: () => import('@/views/mm/order/deliverGoods/print'),
    meta: {
      title: 'pc-router-71',
      detail: true
    }
  }]
}, {
  path: '/srm/purchaser-bidding-hall',
  name: 'purchaserBiddingHall',
  component: () => import('@/views/srm/bidding/purchaser.vue'),
  meta: {
    title: 'pc-router-72',
    requireAuth: true,
    supplierAuth: true,
    detail: true
  }
}, {
  path: '/srm/bidding-hall-no-itemize',
  name: 'biddingHallNoItemize',
  component: () => import('@/views/srm/bidding/hallNoItemize.vue'),
  meta: {
    title: 'pc-router-72',
    requireAuth: true,
    supplierAuth: true,
    detail: true
  }
}, {
  path: '/srm/bidding-hall-itemize',
  name: 'biddingHallItemize',
  component: () => import('@/views/srm/bidding/hallItemize.vue'),
  meta: {
    title: 'pc-router-72',
    requireAuth: true,
    supplierAuth: true,
    detail: true
  }
}, ...asyncRoutes];
// 创建 router
const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes
});
// 菜单数据扁平化
const flatMenus = menu => {
  let menus = [];
  menus.push({
    name: menu.code,
    title: menu.functionName,
    path: menu.functionUri,
    icon: menu.iconCode
  });
  if (menu.children.length) {
    menu.children.forEach(item => {
      menus = [...menus, ...flatMenus(item)];
    });
  }
  return menus;
};
// 匹配当前 route 是否在权限内的菜单中，若匹配则后续添加到 routes 中
const matchMenu = (route, menus) => {
  if (menus.filter(item => route.name === item.name).length === 1) {
    if (route.children && route.children.length) {
      route.children.filter(child => matchMenu(child, menus));
    }
    return route;
  }
  return null;
};
// 将菜单添加到路由
export function addRoutes(menus, permissions) {
  let realMenus = [];
  menus.forEach(menu => {
    // realMenus = [...realMenus, ...flatMenus(menu)]
    realMenus = [...realMenus];
  });
  if (permissions && permissions.length > 0) {
    realMenus = permissionFilter(realMenus, permissions);
  }
  const realRoutes = [];
  // const localRoutes: RouteRecordRaw[] = [fieldTemplateLib, flow]
  // localRoutes.forEach((route: RouteRecordRaw) => {
  //   const r = matchMenu(route, realMenus)
  //   if (r) {
  //     realRoutes.push(r)
  //   }
  // })
  resetRouter();
  realRoutes && realRoutes.forEach(realRoute => {
    router.addRoute(realRoute);
  });
}
/**
 * 过滤菜单(临时)
 */
export function permissionFilter(menus, permissions) {
  const pMenus = [];
  if (!permissions || permissions.length < 1) {
    return menus;
  }
  for (const data of menus) {
    const has = permissions.find(o => {
      return o.permissionName === data.title;
    });
    if (has) {
      pMenus.push(data);
    }
  }
  return pMenus;
}
/**
 * 过滤菜单(临时)
 */
export function permissionFilterTree(menus, permissions) {
  if (!permissions || permissions.length < 1) {
    return menus;
  }
  filterTtree(menus, permissions);
  return menus;
}
function filterTtree(menus, permissions) {
  for (let i = 0; i < menus.length; i++) {
    const data = menus[i];
    const has = permissions.find(o => {
      return o.permissionName === data.functionName;
    });
    if (!has) {
      // 删除
      menus.splice(i, 1);
      --i;
    } else if (data.children && data.children.length > 0) {
      filterTtree(data.children, permissions);
    }
  }
}
// 重置 router
export function resetRouter() {
  const newRouter = createRouter({
    history: createWebHashHistory(),
    routes: []
  });
  router.matcher = newRouter.matcher; // reset router
}
// 根据菜单数据结构获取左侧导航所需数据结构
export function formatMenus(menus) {
  const resultMenus = [];
  menus && menus.forEach(menu => {
    const formatMenuItem = {
      index: menu.Abbrflg,
      label: menu.Menuname,
      icon: menu.iconCode,
      children: formatMenus(menu.children)
    };
    resultMenus.push(formatMenuItem);
  });
  return resultMenus;
}
export function listToTree(data, key, parentKey) {
  if (_.isEmpty(data) || _.isEmpty(key) || _.isEmpty(parentKey)) {
    return [];
  }
  return data.filter(row => {
    const rowTemp = row;
    const children = data.filter(item => item[parentKey] === rowTemp[key] && !_.isEmpty(rowTemp[key]));
    if (children.length > 0) {
      rowTemp.children = children;
    }
    return _.isEmpty(rowTemp[parentKey]);
  });
}
router.beforeEach(async (to, from, next) => {
  if (to.meta.requireAuth) {
    const supplierEntity = JSON.parse(localStorage.getItem('gys_cur_supplier_info'));
    const userInfo = JSON.parse(localStorage.getItem('cur_info'));
    let menus = store.state.menu.menus || [];
    if (menus.length === 0) {
      const localMenus = JSON.parse(localStorage.getItem('menus')) || [];
      if (localMenus.length > 0) {
        menus = localMenus;
      }
    }
    if (to.path !== '/srm/dashboard') {
      const existMenus = menus.filter(m => !_.isEmpty(m.Aliasname) && _.endsWith(to.path, m.Aliasname));
      if (existMenus.length === 0) {
        store.dispatch('tagsView/delView', to);
        next('/srm/dashboard');
      }
    }
    if (localStorage.getItem('authToken')) {
      if (userInfo !== null) {
        store.dispatch('user/setAuthBtns', to);
        next();
      } else if (supplierEntity !== null && to.meta.supplierAuth) {
        store.dispatch('user/setAuthBtns', to);
        next();
      } else {
        next('/auth/login');
      }
    } else {
      next('/auth/login');
    }
  }
  next();
});
export default router;